import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PersonalTask } from 'api/personal-tasks';
import { fetchPersonalTasks } from '../actions';
import { selectPersonalTasks } from '../selectors';

export const usePersonalTasksStore = (): {
  data: PersonalTask[];
  loading: boolean;
} => {
  const { data, loading } = useSelector(selectPersonalTasks);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPersonalTasks());
  }, [dispatch]);

  return {
    data,
    loading,
  };
};
